// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"961348aa","220":"cd892b26","304":"f0ec0928","453":"03346f77","655":"06f449c0","853":"b2f1c131","889":"9f9eb914"}[chunkId] + ".chunk.js";
};